import { useTranslation } from 'react-i18next'

import { WarningIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Button, helpers, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const AlertNotification = ({ title, createdAt, actions, extraInfo }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const alertTime = createdAt ? helpers.getRelativeTime(createdAt, t) : ''
  const hasActions = actions?.length > 0
  const hasSubtitle = alertTime || extraInfo

  return (
    <Styles.MainContainer>
      <Styles.AlertHeader>
        <WarningIcon size={24} color={theme.colors.warning.hover} />
        <Text type="allCapsS" color={theme.colors.warning.hover} customStyles={{ textTransform: 'uppercase' }}>
          {t('Alerta')}
        </Text>
      </Styles.AlertHeader>
      <Styles.Container>
        <Styles.AlertInfoContainer>
          <Text type="titleM" color={theme.colors.warning.hover}>
            {title}
          </Text>
          {hasSubtitle && (
            <Text type="bodySRegular" color={theme.colors.text.subtle}>
              {alertTime}
              {extraInfo}
            </Text>
          )}
        </Styles.AlertInfoContainer>
        {hasActions && (
          <Styles.ActionsContainer>
            {actions.map(action => (
              <Button key={action.id} variant="outlined" size="s" onClick={action.onClick} disabled={action.disabled}>
                {action.icon}
                <Text type="bodySBold">{action.label}</Text>
              </Button>
            ))}
          </Styles.ActionsContainer>
        )}
      </Styles.Container>
    </Styles.MainContainer>
  )
}

export default AlertNotification
